import { render, staticRenderFns } from "./copyProjectUserTable.vue?vue&type=template&id=1038286c&scoped=true&"
import script from "./copyProjectUserTable.vue?vue&type=script&lang=js&"
export * from "./copyProjectUserTable.vue?vue&type=script&lang=js&"
import style0 from "./copyProjectUserTable.vue?vue&type=style&index=0&id=1038286c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038286c",
  null
  
)

export default component.exports